<!-- 关联词条 -->
<template>
  <yxt-drawer
    :destroy-on-close="true"
    size="960px"
    :visible.sync="dialogVisible"
    :before-close="beforeDrawCloseNotWithForm"
    append-to-body
    :title="drawerTitle"
    @close="close"
  >
    <div class="gwnl-related-items__wrap">
      <yxt-tabs
        v-if="setTabs.length === 2"
        v-model="activeName"
        :drawer-top="true"
        @tab-click="onTabClick"
      >
        <yxt-tab-pane
          v-for="tab in setTabs"
          :key="tab.value"
          :label="tab.label"
          :name="tab.value"
        />
      </yxt-tabs>
      <div
        class="select-items__wraper flex"
        :class="{'mt24': setTabs.length === 2}"
      >
        <div class="related-table">
          <ability-selectors
            v-if="activeName === 'ability'"
            ref="ability"
            :limit="limit"
            :list.sync="list"
            :identify="0"
            :get-skills="getSkills"
            @update="updateList"
            @update:selectedData="setItemsNotInFormChangedStatus"
          />
          <Tasks
            v-if="activeName === 'tasks'"
            ref="tasks"
            :is-single="isSingle"
            :limit="limit"
            :rt-model-id="rtModelId"
            :projectId="projectId"
            :selected-data="list"
            :disabled-list="disabledList"
            :scene="scene"
            @change="setTasks"
          />
        </div>
        <!-- 回显区域 -->
        <check-list
          :list="list"
          :source="source"
          @clear="clear"
          @close="closeTag"
        />
      </div>
    </div>
    <div slot="footer">
      <yxt-button @click="close">
        {{ $t('pc_comp_popconfirm_cancelButtonText') }}
      </yxt-button>
      <yxt-button
        type="primary"
        @click="submit"
      >
        {{ $t('pc_biz_common_btn_sure') }}
      </yxt-button>
    </div>
  </yxt-drawer>
</template>
<script>
import drawerBeforeClose from './mixin/drawerBeforeClose';
import abilitySelectors from './components/CheckAbility';
import { getSkillsByTemplateId, getSkillsByProjectId, getJqDetailByProjectId, getProjectModel } from './service';
import Tasks from './components/tasklist';
import checkList from './components/checkList';

const SELECT_TYPE = new Map([
  ['ability', 'pc_biz_select_ability'],
  ['tasks', 'pc_biz_select_duty_tasks']
]);
export default {
  name: 'YxtbizAssociatedTermsSelector',
  components: { abilitySelectors, checkList, Tasks },
  mixins: [drawerBeforeClose],
  props: {
    selectedData: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: Number,
      default: 0
    },
    tabs: {
      type: Array,
      default: () => [
      ]
    },
    limit: {
      type: Number,
      default: Infinity
    },
    projectId: {
      type: String,
      required: true
    },
    isSingle: {
      type: Boolean,
      default: false
    },
    disabledList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    scene: {
      type: Number,
      default: 0 // 0 talent 1 奇点 2 高阶
    },
    source: {
      type: Number,
      default: 1 // 1关联词条，2考核
    }
  },
  data() {
    return {
      skillModelId: '',
      jqId: '',
      rtModelId: '',
      dialogVisible: false,
      list: [],
      activeName: 'ability',
      defaultTabs: [
        {
          label: this.$t('pc_biz_select_ability'),
          value: 'ability',
          component: 'Ability'
        },
        {
          label: this.$t('pc_biz_select_duty_tasks'),
          value: 'tasks',
          component: 'Tasks'
        }
      ]
    };
  },
  computed: {
    drawerTitle() {
      if (this.tabs.length < 2) {
        return this.$t(SELECT_TYPE.get(this.activeName));
      } else {
        return '';
      }
    },
    setTabs() {
      let tabs = this.tabs.length === 0 ? this.defaultTabs : this.tabs.map(tab => {
        if (typeof tab === 'string') {
          return this.defaultTabs.find(item => item.value === tab);
        } else if (typeof tab === 'object' && tab.label && tab.value) {
          return { ...tab };
        } else {
          return null;
        }
      });
      return tabs.filter(item => {
        if (item === null) {
          return false;
        } else if (item.value === 'ability') {
          return !!this.skillModelId;
        } else if (item.value === 'tasks') {
          return !!this.rtModelId;
        }
        return false;
      });
    }
  },
  watch: {
    selectedData: {
      handler: function(v) {
        this.list = [...this.formatSelected(v)];
      }
    },
    activeTab: {
      handler(val) {
        this.activeName = this.tabs[val];
      },
      immediate: true
    },
    setTabs: {
      immediate: true,
      handler(v) {
        if (v[0]) {
          this.activeName = v[0].value;
        }
      }
    },
    activeName: {
      handler(val) {
        this.$nextTick(() => {
          // this.$refs[this.activeName].update()
        });
      }
    }
  },
  methods: {
    getJqIdByProjectId() {
      return new Promise((resolve, reject) => {
        if (this.scene === 0) {
          getJqDetailByProjectId(this.projectId).then((res) => {
            this.skillModelId = res.skillModelId;
            this.rtModelId = res.rtModelId;
            resolve();
          }).catch((err) => {
            reject(err);
          });
        } else {
          getProjectModel(this.projectId).then((res) => {
            this.skillModelId = res.skillModelId;
            this.rtModelId = res.rtModelId;
            resolve();
          }).catch((err) => {
            reject(err);
          });
        }
      });
    },
    getSkills(data, params) {
      return this.scene === 1
        ? getSkillsByProjectId(this.projectId, { ...data, status: -1 }, params)
        : getSkillsByTemplateId(this.skillModelId, { ...data, status: -1 }, params, this.scene === 0);
    },
    onTabClick(e) {
      console.log(e.name);
      if (this.activeName === e.name) return;
      this.activeName = e.name;
      this.$refs[e.name].init();
    },
    close() {
      this.dialogVisible = false;
      this.list = [];
      this.activeName = this.setTabs[0] && this.setTabs[0].value;
    },
    submit() {
      this.dialogVisible = false;
      this.$emit('change', this.isSingle ? this.list[0] : [...this.list]);
      this.activeName = this.setTabs[0] && this.setTabs[0].value;
    },
    async show() {
      await this.getJqIdByProjectId().catch(error => console.log(error));
      this.dialogVisible = true;
      this.list = [...this.formatSelected(this.selectedData)];
      this.resetInitialStatus();
    },
    formatSelected(v) {
      if (v) {
        return v.map(item => {
          if (item.type === 1) {
            return item;
          }
          return {
            ...item,
            rtId: item.id
          };
        });
      }
      return [];
    },
    setTasks(val) {
      let skillData = this.list.filter(item => item.type === 1);
      this.list = [...skillData, ...val];
    },
    closeTag(data) {
      // this.list = this.list.filter(item => item.id !== data.tag.id)
      this.list.splice(this.list.findIndex(item => data.tag.id === item.id), 1);
      this.$refs['ability'] && this.$refs['ability'].closeTag(data.tag);
    },
    clear() {
      this.list = [];
      this.$refs['ability'] && this.$refs['ability'].update();
    },
    updateList(val) {
      this.list = val;
    }
  }
};
</script>
<style lang="scss">
.select-items__wraper {
  position: relative;
  height: 100%;

  .related-table {
    width: calc(100% - 240px);
    height: 100%;

    .person-table {
      flex: 1 1 auto;
      overflow-y: auto;
    }
  }
}

.gwnl-related-items__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;

  .yxt-tabs {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    min-height: 33px;

    .yxt-tabs__header {
      margin-bottom: 24px;
    }

    .yxt-tabs__content {
      display: flex;
      flex: 1;
      overflow: visible;
    }

    .yxt-tab-pane {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      > div {
        height: 100%;
      }
    }
  }
}
</style>
